import { render, staticRenderFns } from "./EmailNotificationsEdit.vue?vue&type=template&id=3eee738a"
import script from "./EmailNotificationsEdit.vue?vue&type=script&lang=ts"
export * from "./EmailNotificationsEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports